import MenuState from "./mixins/MenuState";

window.Vue = require('vue');
window.axios = require('axios');
window.lodash = require('lodash');
window.eventBus = new Vue;

let googleApiKey = window.drupalSettings.ef2_custom?.googleApiKey ?? '';
let googleRegion = window.drupalSettings.ef2_custom?.googleApiKey ?? '';
let googleLang = window.drupalSettings.ef2_custom?.lang_code ?? '';

import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
    load: {
        key: googleApiKey,
        libraries: 'places',
        region: googleRegion,
        language: `${googleLang}`
    }
});

import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
Vue.use(PerfectScrollbar, { options: { 'wheelPropagation': false } });

import vSelect from 'vue-select';
Vue.component('v-select', vSelect);
import 'vue-select/dist/vue-select.css';

import VueYoutube from 'vue-youtube';
Vue.use(VueYoutube);

import VueMq from 'vue-mq';
Vue.use(VueMq, {
    breakpoints: { // default breakpoints - customize this
        mobile: 768,
        tablet: 1024,
        laptop: 1250,
        desktop: Infinity,
    }
})

import VueAccessibleModal from 'vue-accessible-modal';
import 'vue-accessible-modal/dist/index.css';
Vue.use(VueAccessibleModal, {transition: "fade"});

Vue.component('nexdrive-filter-toggle', require('../vue/components/FilterToggle').default);
Vue.component('nexdrive-circle-slider', require('../vue/components/CircleSlider').default);
Vue.component('nexdrive-circle-slider-text', require('../vue/components/CircleSliderText').default);
Vue.component('nexdrive-accordion', require('../vue/components/Accordion').default);
Vue.component('nexdrive-product-carousel', require('../vue/components/ProductCarousel').default);
Vue.component('nexdrive-youtube-wrapper', require('../vue/components/YoutubeWrapper').default);
Vue.component('nexdrive-high-contrast-switch', require('../vue/components/HighContrastSwitch').default);
Vue.component('nexdrive-finder', require('../../../../../modules/custom/nexdrive_base/js/components/NexdriveFinder').default);
Vue.component('nexdrive-map-widget', require('../vue/components/Map/MapWidget').default);
Vue.component('nexdrive-pop-up-trigger', require('../vue/components/PopUpWhoAreYou/PopUpTrigger').default);

Vue.component('nexdrive-occasion-overview', require('../../../../../modules/custom/nexdrive_occasions/js/components/OccasionOverview').default);
Vue.component('occasion-filter-group', require('../../../../../modules/custom/nexdrive_occasions/js/components/OccasionFilterGroup').default);
Vue.component('occasion-dropdown-filter', require('../../../../../modules/custom/nexdrive_occasions/js/components/OccasionDropdownFilter').default);
Vue.component('occasion-range-filter', require('../../../../../modules/custom/nexdrive_occasions/js/components/OccasionRangeFilter').default);
Vue.component('occasion-list-item', require('../../../../../modules/custom/nexdrive_occasions/js/components/OccasionListItem').default);
Vue.component('loader', require('../../../../../modules/custom/nexdrive_occasions/js/components/Loader').default);

new Vue({
    'el': '#page-wrapper',

    comments: true,

    mixins: [MenuState],

    mounted() {
        window.eventBus.$on('menu-toggled', (payload) => {
            if (payload) {
                document.body.classList.add("nav-open");
            } else {
                document.body.classList.remove("nav-open");
            }
        });

        window.eventBus.$on('filter-toggled', (payload) => {
            if (payload) {
                document.body.classList.add("filter-open");
            } else {
                document.body.classList.remove("filter-open");
            }
        });
    },

    methods: {
        handleClose(payload) {
            localStorage.setItem('repair-shop', '0')
        }
    }
});
